@if (dialogState() === 'show') {
  <h1 mat-dialog-title>
    <div class="title">
      @switch (data.type) {
        @case (PlanUnassignedRideType.Unassigned) {
          <span>Restrit plannen</span>
        }
        @default {
          <span>Passagier verplaatsen</span>
        }
      }
    </div>
    <div class="buttons">
      @if (data.type === PlanUnassignedRideType.Unassigned) {
        <button
          mat-icon-button
          aria-label="Restrit verwijderen"
          (click)="deleteUnassignedRide()"
          matTooltip="Restrit verwijderen"
        >
          <mat-icon>delete</mat-icon>
        </button>
      }
      <button mat-icon-button aria-label="Sluiten" mat-dialog-close>
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </h1>

  <div mat-dialog-content class="dialog-content">
    <div>
      <div class="user-info">
        <p class="dialog-title">Gegevens passagier</p>
        <table class="info-table">
          <tr>
            <th class="info-subtitle">Naam:</th>
            <td>
              {{ data.passenger.title }} {{ data.passenger.phoneNumber ? '(' + data.passenger.phoneNumber + ')' : '' }}
            </td>
          </tr>
          <tr>
            <th class="info-subtitle">Van:</th>
            <td>
              <a
                [href]="'https://maps.google.com/?q=' + encodeURIComponent(getFullLocationString(data.passenger.from))"
                target="_blank"
                rel="noopener noreferrer"
              >
                {{ getFullLocationString(data.passenger.from) }}
              </a>
            </td>
          </tr>
          <tr>
            <th class="info-subtitle">Naar:</th>
            <td>
              <a
                [href]="'https://maps.google.com/?q=' + encodeURIComponent(getFullLocationString(data.passenger.to))"
                target="_blank"
                rel="noopener noreferrer"
              >
                {{ getFullLocationString(data.passenger.to) }}
              </a>
            </td>
          </tr>
        </table>
        @if (data.passenger?.particularityIds?.length > 0) {
          <div class="info-subtitle">Bijzonderheden:</div>
          <div class="particularities">
            @for (particularity of dataStore.selectedOrganisation.particularities; track particularity) {
              @if (data.passenger?.particularityIds?.includes(particularity.id)) {
                <div class="icon active" [matTooltip]="particularity.name">
                  <mat-icon [svgIcon]="particularity.id"></mat-icon>
                </div>
              }
            }
          </div>
        }
      </div>
      <form [formGroup]="rideTimeForm">
        <div class="form-field-group-wrapper" [class.valid-time]="!invalidTimeCombination()">
          <div class="dialog-subtitle">Ophaalmoment</div>
          <div class="form-field-group">
            <mat-form-field class="mat-form-field-no-subscript" hideRequiredMarker="true">
              <mat-label>Uur</mat-label>
              <mat-select formControlName="startHour">
                @for (hour of hours(); track hour) {
                  @if (hour <= endHour && hour >= startHour) {
                    <mat-option [value]="hour">{{ hour }}</mat-option>
                  }
                }
              </mat-select>
              @if (this.rideTimeForm.controls.startHour.hasError('required')) {
                <mat-error>Dit veld is verplicht.</mat-error>
              }
            </mat-form-field>
            <mat-form-field class="mat-form-field-no-subscript" hideRequiredMarker="true">
              <mat-label>Minuten</mat-label>
              <mat-select formControlName="startMinute">
                @for (minute of minutes(); track minute) {
                  <mat-option [value]="minute.val">{{ minute.text }}</mat-option>
                }
              </mat-select>
              @if (this.rideTimeForm.controls.startMinute.hasError('required')) {
                <mat-error>Dit veld is verplicht.</mat-error>
              }
            </mat-form-field>
          </div>
          <div class="dialog-subtitle">Afzetmoment</div>
          <div class="form-field-group">
            <mat-form-field class="mat-form-field-no-subscript" hideRequiredMarker="true">
              <mat-label>Uur</mat-label>
              <mat-select formControlName="endHour">
                @for (hour of hours(); track hour) {
                  @if (hour <= endHour && hour >= startHour) {
                    <mat-option [value]="hour">{{ hour }}</mat-option>
                  }
                }
              </mat-select>
              @if (this.rideTimeForm.controls.endHour.hasError('required')) {
                <mat-error>Dit veld is verplicht.</mat-error>
              }
            </mat-form-field>
            <mat-form-field class="mat-form-field-no-subscript" hideRequiredMarker="true">
              <mat-label>Minuten</mat-label>
              <mat-select formControlName="endMinute">
                @for (minute of minutes(); track minute) {
                  <mat-option [value]="minute.val">{{ minute.text }}</mat-option>
                }
              </mat-select>
              @if (this.rideTimeForm.controls.endMinute.hasError('required')) {
                <mat-error>Dit veld is verplicht.</mat-error>
              }
            </mat-form-field>
          </div>
          @if (invalidTimeCombination()) {
            <mat-error>Het ophaalmoment moet plaatsvinden voor het afzetmoment.</mat-error>
          }
        </div>
        <div class="buttons">
          <button mat-flat-button color="primary" (click)="createNewRide()" [disabled]="!rideTimeForm.valid">
            @switch (data.type) {
              @case (PlanUnassignedRideType.Unassigned) {
                Rit handmatig plannen
              }
              @default {
                Rit maken
              }
            }
          </button>
          <button
            mat-flat-button
            class="primary-color"
            [disabled]="!rideTimeForm.valid || invalidTimeCombination() || deleting()"
            (click)="refreshPotentialRides()"
          >
            @switch (data.type) {
              @case (PlanUnassignedRideType.Unassigned) {
                Zoek bestaande ritten
              }
              @default {
                Zoek bestaande ritten voor verplaatsing
              }
            }
          </button>
        </div>
      </form>
    </div>
    @if (!loadingRides()) {
      <div class="dialog-title">Bestaande ritten</div>
      @if (potentialRides().length > 0) {
        <div class="potential-rides">
          @for (ride of potentialRides(); track ride) {
            <mat-card class="potential-ride">
              <div class="info-title">
                <span>Ritgegevens</span>
                <button
                  mat-icon-button
                  class="add-passenger"
                  aria-label="Passagier toevoegen"
                  [disabled]="
                    !rideTimeForm.valid ||
                    invalidTimeCombination() ||
                    invalidTimeForRides.includes(ride.id) ||
                    deleting()
                  "
                  [matTooltip]="'Passagier toevoegen'"
                  (click)="addUserToExistingRide(ride)"
                >
                  <mat-icon>add</mat-icon>
                </button>
              </div>
              <table class="info-table">
                <tr>
                  <th class="info-subtitle">Datum:</th>
                  <td>{{ ride.start.toDate() | date: 'dd-MM-yyyy' }}</td>
                </tr>
                <tr>
                  <th class="info-subtitle">Starttijd:</th>
                  <td>{{ ride.start.toDate() | date: 'HH:mm' }}</td>
                </tr>
                <tr>
                  <th class="info-subtitle">Eindtijd:</th>
                  <td>{{ ride.end.toDate() | date: 'HH:mm' }}</td>
                </tr>
                <tr>
                  <th class="info-subtitle">Vrij plaatsen:</th>
                  <td>{{ ride.availableSeats }}/{{ getVehicleSeats(ride.vehicleId) }}</td>
                </tr>
                @if (ride.locationsOrder?.length > 0) {
                  <tr>
                    <th class="info-subtitle">Startlocatie:</th>
                    <td>
                      <a
                        [href]="'https://maps.google.com/?q=' + encodeURIComponent(ride.locationsOrder[0].fullLocation)"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {{ ride.locationsOrder[0].fullLocation }}
                      </a>
                    </td>
                  </tr>
                }
                @if (ride.locationsOrder?.length > 1) {
                  <tr>
                    <th class="info-subtitle">Eindlocatie:</th>
                    <td>
                      <a
                        [href]="
                          'https://maps.google.com/?q=' +
                          encodeURIComponent(ride.locationsOrder[ride.locationsOrder.length - 1].fullLocation)
                        "
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {{ ride.locationsOrder[ride.locationsOrder.length - 1].fullLocation }}
                      </a>
                    </td>
                  </tr>
                }
              </table>
            </mat-card>
          }
        </div>
      } @else if (timeHasPassed()) {
        <p>
          Geen geschikte ritten gevonden voor deze passagier, omdat het gewenste ophaal- en afzetmoment al voorbij is.
        </p>
      } @else {
        <p>Geen geschikte ritten gevonden voor de passagier.</p>
      }
    } @else {
      <div class="loading-container">
        <mat-spinner></mat-spinner>
      </div>
    }
  </div>
}
